require('./RAStrategyDetailModal.scss');

// @vendor
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const { recordLinkV2 } = require('utilities/tagging');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKButton } = require('components/commons/OKButton/OKButton');
const FeatureTogglingRender = require('components/conditionalRender/featureTogglingRender');

// @constants
const { ESG_PRODUCT } = require('constants/flagBasedFeatures');
const {
    PROC_RA_MANAGMENT_PLAN_DETAIL_MODAL,
} = require('../../raConstants/index');

class RAStrategyDetailModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleContinue = this.handleContinue.bind(this);
        this.handleOnOpenModal = this.handleOnOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
    }

    handleContinue() {
        const { onModalClose } = this.props;

        recordLinkV2({
            action: 'continue',
            format: 'button',
            component: 'modal/currentDistributionStrategy',
            element: 'continue',
            categoriaEvento: PROC_RA_MANAGMENT_PLAN_DETAIL_MODAL,
            accionEvento: 'currentDistributionStrategy',
            eventLabel: 'continue',
        });
        onModalClose();
    }

    handleOnOpenModal() {
        recordLinkV2({
            action: 'open',
            format: 'modal',
            component: 'modal/currentDistributionStrategy',
            element: 'full',
            categoriaEvento: PROC_RA_MANAGMENT_PLAN_DETAIL_MODAL,
            accionEvento: 'currentDistributionStrategy',
            eventLabel: 'open',
        });
    }

    handleCloseModal() {
        const { onModalClose } = this.props;

        recordLinkV2({
            action: 'close',
            format: 'cross',
            component: 'modal/currentDistributionStrategy',
            element: 'close',
            categoriaEvento: PROC_RA_MANAGMENT_PLAN_DETAIL_MODAL,
            accionEvento: 'currentDistributionStrategy',
            eventLabel: 'close',
        });
        onModalClose();
    }

    render() {
        const { isModalOpen, tableContent, moreInfoLinks } = this.props;

        const contentModal = (
            <div className="ra-strategy-detail-modal__section-table">
                <h3 className="ra-strategy-detail-modal__section-title">
                    <FormattedText value="raManagementPlanView-distributionDetailsTitle" />
                </h3>
                <FeatureTogglingRender notAllowedProductKey={ESG_PRODUCT}>
                    <div className="ra-strategy-detail-modal__section-esg-tag">
                        <i className="ra-strategy-detail-modal__section-esg-icon" />
                        <FormattedText value="raManagementPlanView-raManagementPlanView_esgTag" />
                    </div>
                </FeatureTogglingRender>
                <div className="ra-strategy-detail-modal__table-container">
                    {tableContent}
                </div>
                <div className="ra-strategy-detail-modal__more-info-link">
                    <p>{moreInfoLinks}</p>
                </div>
                <div className="ra-strategy-detail-modal__buttons">
                    <OKButton modifier="primary" onClick={this.handleContinue}>
                        <FormattedText value="raManagementPlanView-continueButton" />
                    </OKButton>
                </div>
            </div>
        );

        return (
            <OKModal
                content={contentModal}
                isOpen={isModalOpen}
                onAfterOpen={this.handleOnOpenModal}
                onCloseCallback={this.handleCloseModal}
                shouldCloseOnOverlayClick={false}
                size="large"
                titleAlignment="center"
            />
        );
    }
}

RAStrategyDetailModal.propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    onModalClose: PropTypes.bool.isRequired,
    tableContent: PropTypes.bool.isRequired,
    moreInfoLinks: PropTypes.bool.isRequired,
};

module.exports = withRouter(RAStrategyDetailModal);
